module.exports = {
  texturesData: () => {
    return{
      "IONIQ 5 EV-POWER": require('./textures/inoniq5.data'),
      "TUCSON HEV LIMITED": require('./textures/tucson.data'),
      "PALISADE SPORT": require('./textures/palisade.data'),
      "STARIA LUJO": require('./textures/staria.data'),
      "VENUE LIMITED AT": require('./textures/venue.data'),
      "HB20 ADVANCE": require('./textures/hb20.data'),
      "HB20S ADVANCE": require('./textures/hb20s.data'),
      "CRETA PREMIUM": require('./textures/creta.data'),
      "KONA HEV LIMITED": require('./textures/kona.data'),
      "SANTA FE HEV LIMITED 4x4": require('./textures/santafe.data'),
    }
  }
}